type Callback<T = unknown> = (data: T) => void | Promise<void>;
type Subscribers = Record<string, Callback<unknown>[]>;

let subscribers: Subscribers = {};

function subscribe<T = unknown>(eventName: string, callback: Callback<T>): () => void {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback as Callback<unknown>];

  return function unsubscribe(): void {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish<T = unknown>(eventName: string, data: T): Promise<void[]> {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => Promise.resolve(callback(data)));
    return Promise.all(promises);
  } else {
    return Promise.resolve([]);
  }
}

export { subscribe, publish };

declare global {
  interface Window {
    subscribe: typeof subscribe;
    publish: typeof publish;
  }
}
